import api from "./api";

const settingsService = {
  // Get user preferences
  getPreferences: async () => {
    try {
      const response = await api.get("/preferences");
      return response.data;
    } catch (error) {
      console.error("Preferences API error:", error);
      throw error;
    }
  },

  // Update user preferences
  updatePreferences: async (preferences: any) => {
    try {
      const response = await api.put("/preferences", { preferences });
      return response.data;
    } catch (error) {
      console.error("Update preferences API error:", error);
      throw error;
    }
  },

  // Get currency rates
  getCurrencyRates: async () => {
    try {
      const response = await api.get("/currency-rates");
      return response.data;
    } catch (error) {
      console.error("Currency rates API error:", error);
      throw error;
    }
  },

  // Update user balance (admin only)
  updateUserBalance: async (userId: number, balance: number) => {
    try {
      const response = await api.put(`/admin/users/${userId}/balance`, {
        balance,
      });
      return response.data;
    } catch (error) {
      console.error("Update balance API error:", error);
      throw error;
    }
  },
};

export default settingsService;
